import { FC } from 'react';

import { Link, usePage } from '@inertiajs/react';

import { EditOfferForm } from './Edit/EditOfferForm';
import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbList,
    BreadcrumbPage,
    BreadcrumbSeparator,
} from '../../../components/ui/Breadcrumb';
import { Routes } from '../../../models/routes';

type PageProps = {
    returnTo?: string;
};

const New: FC = () => {
    const { returnTo } = usePage<PageProps>().props;

    return (
        <div className="gap-2 pb-6">
            <Breadcrumb className="mt-6 mb-2">
                <BreadcrumbList>
                    <BreadcrumbItem>
                        <BreadcrumbLink asChild>
                            <Link href={returnTo || Routes.Offers}>
                                Мої пропозиції
                            </Link>
                        </BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbSeparator />
                    <BreadcrumbItem>
                        <BreadcrumbPage>Редагувати пропозицію</BreadcrumbPage>
                    </BreadcrumbItem>
                </BreadcrumbList>
            </Breadcrumb>

            <EditOfferForm />
        </div>
    );
};

export default New;
